import { useEffect, useRef, useState } from "react";
import { Footer } from "../components/Footer";
import { NavLink } from "react-router-dom";

import axios from "axios";
import { TestimonialVideoSlider } from "../components/TestimonialVideoSlider";
import TestimonialImageDisplay from "../components/TestimonialImageDisplay";

const initialState = { youtube_link: [], testimonial: [] };

const Testimonial = () => {
  const [testimonialData, setTestimonialData] = useState(initialState);
  const DivRef = useRef(null);
  const testimonial_api = process.env.REACT_APP_API_URL_TESTIMONIAL;

  useEffect(() => {
    if (DivRef.current) {
      DivRef.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, []);

  useEffect(() => {
    fetchTestimonials();
  },[])

  const fetchTestimonials = async () => {
    const response = await axios.get(testimonial_api);
      const data = response.data;
      setTestimonialData(data);
    try {
      
    } catch (error) {
      console.log(error)
    } finally {
    }
  };

  return (
    <div>
      <div className="page-banner bannerTestimonial" ref={DivRef}>
        <h4 className="banner-title">{/* Testimonials */}</h4>
      </div>
      {testimonialData?.youtube_link?.length > 0 && (
        <section className="flex justify-center items-center flex-col my-16 w-full sm:w-[90%] 2xl:w-[70%] mx-auto">
          <h2 className=" text-4xl sm:text-5xl text-[#00034d] font-bold leading-[4rem] mb-6 text-center lg:text-left">
            Testimonial Videos
          </h2>
          <div className="w-full">
            <TestimonialVideoSlider items={testimonialData?.youtube_link} />
          </div>
        </section>
      )}
      {testimonialData?.testimonial?.length > 0 && (
        <section className="w-full">
          <TestimonialImageDisplay data={testimonialData?.testimonial} />
        </section>
      )}
      <section className="flex items-center justify-center flex-col gap-4 my-16">
        <h2 className="text-center  text-[40px] text-[#00034D] font-medium w-[90%] md:w-[70%] leading-[48px]">
          Top universities. Global exposure. A brighter future. <br /> Let’s
          make it happen together!
        </h2>
        <NavLink to="/Contact-us" className="mt-4 btn btn-primary">
          Enquire Now
        </NavLink>
      </section>
      <Footer />
    </div>
  );
};

export default Testimonial;
